const trustItems = [
  {
    icon: 'ri-scales-3-line',
    title: 'Transparent Comparisons',
    desc: 'No hidden fees, no biased rankings. See real data, real reviews and real pricing from verified providers.',
    color: 'bg-primary-50',
    iconColor: 'text-primary-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Partner-Led Marketplace',
    desc: 'Every installer, manufacturer and finance provider is verified. Quality and trust come first.',
    color: 'bg-accent-50',
    iconColor: 'text-accent-500',
  },
  {
    icon: 'ri-book-open-line',
    title: 'Customer-First Education',
    desc: 'Clear guides, tools and resources to help Australians make informed renewable energy decisions.',
    color: 'bg-secondary-50',
    iconColor: 'text-secondary-500',
  },
  {
    icon: 'ri-stack-line',
    title: 'Scalable Platform',
    desc: 'Built to grow with the market — from simple comparisons today to full energy optimisation tomorrow.',
    color: 'bg-rose-50',
    iconColor: 'text-rose-500',
  },
];

export default function TrustSection() {
  return (
    <section className="relative py-20 md:py-28 px-4 md:px-6 lg:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">Our Values</span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight" style={{ color: '#111827' }}>
              Built On
              <span className="relative mx-3 italic font-serif" style={{ color: '#2FA84F' }}>
                Trust,
              </span>
              Transparency <br />&amp; Sustainability
            </h2>
            <p className="mt-5 text-base md:text-lg text-foreground-600 leading-relaxed">
              AK Energy is designed to help Australians make better renewable energy decisions through clear information, trusted partners and transparent processes.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            {trustItems.map((item, i) => (
              <div
                key={item.title}
                className={`${item.color} rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-default`}
                style={{ animationDelay: `${i * 100}ms` }}
              >
                <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center mb-3">
                  <i className={`${item.icon} ${item.iconColor} text-lg`}></i>
                </div>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1.5">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            ))}

            <div className="sm:col-span-2 bg-foreground-900 rounded-2xl p-5 md:p-6 flex items-center gap-4">
              <div className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center flex-shrink-0">
                <i className="ri-earth-line text-white text-xl"></i>
              </div>
              <div>
                <h3 className="font-heading text-sm font-bold text-white mb-1">Built for Australia&rsquo;s Energy Future</h3>
                <p className="text-xs text-white/70 leading-relaxed">Designed specifically for the Australian energy market, regulations, rebates and conditions.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}